/** Fenêtre du hub 2 uniquement. La PWA et le hub 1 ne passent pas ici. */

function requestUrl(input: RequestInfo | URL): string {
  return typeof input === "string" ? input : input instanceof URL ? input.href : input.url;
}

/** Ces deux appels lisent le cookie. Un en-tête en plus les fait échouer hors de la page. */
function isCookieSessionCall(input: RequestInfo | URL): boolean {
  try {
    return /\/(hub2-whoami|chat-ping)\.php$/i.test(new URL(requestUrl(input), window.location.href).pathname);
  } catch {
    return false;
  }
}

function stampHub2(input: RequestInfo | URL): boolean {
  const raw = typeof input === "string" ? input : input instanceof URL ? input.href : input.url;
  try {
    const url = new URL(raw, window.location.href);
    if (url.origin === window.location.origin) return true;
    return url.hostname.endsWith("aureliasuite.fr") && /\/api_(suite|chat)(\/|$)/.test(url.pathname);
  } catch {
    return false;
  }
}

function installHub2Fetch(): void {
  if (window.__chatHub2Fetch) return;
  window.__chatHub2Fetch = true;
  const native = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    if (!isChatHub2Desk() || !stampHub2(input)) return native(input, init);
    if (isCookieSessionCall(input)) {
      const sessionInit: RequestInit = { credentials: "include", cache: "no-store", ...init };
      if (input instanceof Request) return native(new Request(input, sessionInit));
      return native(input, sessionInit);
    }
    const headers = new Headers(init?.headers || (input instanceof Request ? input.headers : undefined));
    headers.set("X-Aurelia-Hub", "2");
    headers.delete("X-User-Id");
    if (input instanceof Request) return native(new Request(input, { ...init, headers }));
    return native(input, { ...init, headers });
  };
}

function markChatHub2FromDesk(): void {
  try {
    if (window.parent === window) return;
    if (new URLSearchParams(window.location.search).get("aurelia_hub") === "2") {
      window.__chatHub2 = true;
      installHub2Fetch();
    }
  } catch {
    /* onglet ou PWA : la connexion actuelle reste */
  }
}

markChatHub2FromDesk();

export function isChatHub2Desk(): boolean {
  return window.__chatHub2 === true;
}

declare global {
  interface Window {
    __chatHub2?: boolean;
    __chatHub2Fetch?: boolean;
    __chatHub2UserId?: string;
  }
}
